import startIcon from '@/assets/start.svg';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from '@/components/ui/card';
import { Handle, Position } from '@xyflow/react';
import { useCallback } from 'react';
import NodeToolbar from '../NodeToolbar';

const handleStyle = { left: 10 };

export default function StartNode({
  setNodes,
  workflowId,
  selected,
}: {
  setNodes: any;
  workflowId: string;
  selected: boolean;
}) {
  const onChange = useCallback((evt: any) => {
    console.log(evt.target.value);
  }, []);
  return (
    <Card
      className={`w-[200px] rounded-md shadow-none transition-all duration-200
    ${selected ? 'border-2 border-blue-500' : 'border'}
    hover:shadow-md hover:border-blue-500 relative`}    >

      <Handle type="target" position={Position.Top} />
      <NodeToolbar
        setNodes={setNodes}
        allowDelete={false}
        workflowId={workflowId}
      />
      <CardContent className="flex h-full w-full flex-1 items-center justify-start p-2">
        <Avatar className="h-6 w-6">
          <AvatarImage src={startIcon} className="bg-muted p-[7px]" />
          <AvatarFallback>Z</AvatarFallback>
        </Avatar>
        <div className="ml-2 flex flex-col">
          <CardTitle className="text-[8px]">Start</CardTitle>
          <CardDescription className="max-w-lg text-balance text-[8px] leading-relaxed">
            Start Workflow
          </CardDescription>
        </div>
      </CardContent>

      <Handle type="source" position={Position.Bottom} id="a" />
    </Card>
  );
}
